export const BET_COUNT_MIN = 1;
export const BET_COUNT_MAX = 10;
export const LIMIT = 18;
export const COUNT_CARDS_IN_ROW = 3;
export const COUNT_CARDS_IN_ROW_MOBILE = 1;
export const ANIMATION_VIDEO_DURATION = 11000; // 11 seconds
export const GAME_RESULT_TIMEOUT = 60000; // 1 minute
